<template>
  <div class="sticky-box">
    <!-- 首次登入獎勵自訂彈窗 -->

    <div class="header">
      <div class="logo" style="flex: 1">
        <img class="logo-img cursor-pointer" @click="onLogoImageClick" src="@/assets/images/logo.jpeg" />
        <div
            v-if="!security && home && $route.path != '/subscribe' && $route.path != '/payment' && $route.path != '/checkout'"
            style="display: flex; flex-wrap: wrap; justify-content: flex-start; flex: 1"
        >
          <span class="cursor-pointer" @click="onAbout">{{ $t("other.about") }}</span>
          <span class="cursor-pointer" @click="onPlatform">{{ $t("other.platform") }}</span>
          <span class="cursor-pointer" @click="onFaq">{{ $t("other.faq") }}</span>
          <span class="cursor-pointer" @click="onContact">{{ $t("other.contact") }}</span>
        </div>
        <div v-if="userInfo.roleName == roleNameStudent && !home" style="margin-right: 10px;">
          <el-dropdown trigger="click" v-if="userInfo.roleName == roleNameStudent" style="border-radius: 24px">
            <div class="relative">
              <button
                  class="relative flex items-center justify-center rounded-2xl transition-all active:scale-95"
                  :style="btnStyleX"
              >
                <span class="text-xl leading-none" style="display:flex;align-items:center;">
                <img v-if="btnIconX.showImg" class="cursor-pointer" style="width: 1.2rem; height: 1.2rem;background-color: #d37525" :src="btnIconX.imgSrc" />
                {{ btnIconX.label }}
              </span>
                <span class="absolute -bottom-0.5 -right-0.5 w-3 h-3 rounded-full border-2 border-white" :style="dotStyleX"></span>
              </button>
            </div>

            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="modeChange(1)"><span class="cursor-pointer">
                <img class="cursor-pointer" v-if="userInfo.roleName == roleNameStudent" style="width: 1rem; height: 1rem;background-color: #d37525" src="@/assets/images/adventure-mode.png" />{{ $t("studentProgramme.adventureMode") }}</span></el-dropdown-item>
              <el-dropdown-item @click.native="modeChange(2)"><span class="cursor-pointer">
                <img class="cursor-pointer" v-if="userInfo.roleName == roleNameStudent" style="width: 1rem; height: 1rem;background-color: #d37525" src="@/assets/images/library-mode.png" />{{ $t("studentProgramme.libraryMode") }}</span></el-dropdown-item>
<!--              <el-dropdown-item @click.native="modeChange(3)">-->
<!--                <span class="cursor-pointer">-->
<!--                <img class="cursor-pointer" v-if="userInfo.roleName == roleNameStudent" style="width: 1rem; height: 1rem;background-color: #d37525" src="@/assets/images/homework-mode.png" />-->
<!--                  {{ $t("studentProgramme.homework") }}</span>-->
<!--              </el-dropdown-item>-->
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div v-if="userInfo.roleName == roleNameStudent && !home">
          <el-dropdown trigger="click" v-if="userInfo.roleName == roleNameStudent" style="border-radius: 24px">
            <div class="relative">
              <button
                  class="relative flex items-center justify-center rounded-2xl transition-all active:scale-95"
                  :style="btnStyleY"
              >
                <span class="text-xl leading-none">{{ btnIconY }}</span>
                <span class="absolute -bottom-0.5 -right-0.5 w-3 h-3 rounded-full border-2 border-white" :style="dotStyle"></span>
              </button>
            </div>

            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="onGacha"><span class="cursor-pointer">🎴 {{ $t('gacha.luckyGacha') }}</span></el-dropdown-item>
              <el-dropdown-item @click.native="onMyGacha"><span class="cursor-pointer">📦 {{ $t('gacha.myCollection') }}</span></el-dropdown-item>
              <el-dropdown-item @click.native="onCardShop"><span class="cursor-pointer">🏪 {{ $t('gacha.cardShop') }}</span></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="userinfo" v-if="!security && $route.path != '/subscribe' && $route.path != '/checkout'">

        <span class="cursor-pointer" v-if="$store.getters.language !== languageZhTc && home" @click="onLangText('zh_tc')">繁</span>
        <span class="cursor-pointer" v-else-if="$store.getters.language !== languageEn && home" @click="onLangText(languageEn)">EN</span>
<!--        <span class="cursor-pointer" v-if="$store.getters.language !== languageZhTc" @click="onLangText('zh_tc')">繁</span>-->
<!--        <span class="cursor-pointer" v-else-if="$store.getters.language !== languageEn" @click="onLangText(languageEn)">EN</span>-->
        <div v-if="$route.path != '/payment'" class="userinfo">
          <el-badge is-dot v-if="dailyTaskWorkId" class="item cursor-pointer">
            <img class="cursor-pointer" style="width: 2rem; height: 2rem" src="@/assets/images/renwu.png" @click="onViewTasks"/>
          </el-badge>
          <el-badge v-if="!dailyTaskWorkId" class="item cursor-pointer">
            <img class="cursor-pointer" style="width: 2rem; height: 2rem" src="@/assets/images/renwu.png" @click="onViewTasks"/>
          </el-badge>
          <el-dropdown trigger="click" v-if="userInfo.roleName == roleNameStudent && links">
            <el-badge is-dot v-if="links" class="item cursor-pointer">
              <img class="cursor-pointer" style="width: 2rem; height: 2rem" src="@/assets/images/daitijiao.png" />
            </el-badge>
            <el-badge v-if="!links" class="item cursor-pointer">
              <img class="cursor-pointer" style="width: 2rem; height: 2rem" src="@/assets/images/daitijiao.png" />
            </el-badge>
            <el-dropdown-menu slot="dropdown">
              <!-- 标题 -->
              <el-dropdown-item disabled style="cursor: default; color: #333; font-weight: bold; font-size: 14px;">
                <span style="padding: 4px 0;">{{ $t("redis.title") }}</span>
              </el-dropdown-item>
              <el-dropdown-item>
                <div v-html="links"></div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-badge :value="countNewHomework" v-if="userInfo.roleName == roleNameStudent" class="item cursor-pointer">
            <img class="cursor-pointer" @click="testMode" style="width: 2rem; height: 2rem" src="@/assets/images/zuoye.png" />
          </el-badge>
<!--            <el-dropdown trigger="click" v-if="userInfo.roleName == roleNameStudent">-->
<!--              <el-badge :value="countNewHomework" v-if="userInfo.roleName == roleNameStudent" class="item cursor-pointer">-->
<!--                <img class="cursor-pointer" @click="testMode" style="width: 2rem; height: 2rem" src="@/assets/images/zuoye.png" />-->
<!--              </el-badge>-->
<!--              <el-dropdown-menu slot="dropdown">-->
<!--                &lt;!&ndash; 动态链接 &ndash;&gt;-->
<!--                <el-dropdown-item>-->
<!--                  <a style="display:inline-block; padding:6px 12px; margin:4px 0; background:#FFF3E0; border-radius:8px; color:#E65100; text-decoration:none; font-size:16px; font-weight:bold; border:2px solid #FFB74D; transition:all 0.3s;"-->
<!--                     v-if="dailyTaskWorkId!=null" type="warning" plain @click="toExamination">今天任務</a>-->
<!--                </el-dropdown-item>-->
<!--              </el-dropdown-menu>-->
<!--            </el-dropdown>-->
            <el-divider direction="vertical" v-if="userInfo.roleName == roleNameStudent"></el-divider>
<!--            <el-dropdown trigger="click" v-if="userInfo.roleName == roleNameStudent" style="border-radius: 24px">-->
<!--              <div class="relative">-->
<!--                <button-->
<!--                    class="relative flex items-center justify-center rounded-2xl transition-all active:scale-95"-->
<!--                    title="Card sections"-->
<!--                    :style="btnStyle"-->
<!--                >-->
<!--                  <span class="text-xl leading-none" style="font-size: 16px;">{{ btnIcon }}</span>-->
<!--                  <span class="absolute -bottom-0.5 -right-0.5 w-3 h-3 rounded-full border-2 border-white" :style="dotStyle"></span>-->
<!--                </button>-->
<!--              </div>-->
<!--              &lt;!&ndash;            <el-button circle><span style="font-size: 18px;">🎴</span></el-button>&ndash;&gt;-->
<!--              &lt;!&ndash;            <svg width="36" height="36" viewBox="-2 -2 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">&ndash;&gt;-->
<!--              &lt;!&ndash;              <g>&ndash;&gt;-->
<!--              &lt;!&ndash;                <circle cx="12" cy="12" r="11" fill="#F59E0B" stroke="#D97706" stroke-width="1.5" />&ndash;&gt;-->
<!--              &lt;!&ndash;                <circle cx="12" cy="12" r="8" fill="#FCD34D" opacity="0.5" />&ndash;&gt;-->
<!--              &lt;!&ndash;                <text x="12" y="16" text-anchor="middle" font-size="9" font-weight="800" fill="#92400E" font-family="Nunito,sans-serif">M</text>&ndash;&gt;-->
<!--              &lt;!&ndash;              </g>&ndash;&gt;-->
<!--              &lt;!&ndash;            </svg>&ndash;&gt;-->
<!--              <el-dropdown-menu slot="dropdown">-->
<!--                <el-dropdown-item @click.native="onGacha"><span class="cursor-pointer">🎴 {{ $t('gacha.luckyGacha') }}</span></el-dropdown-item>-->
<!--                <el-dropdown-item @click.native="onMyGacha"><span class="cursor-pointer">📦 {{ $t('gacha.myCollection') }}</span></el-dropdown-item>-->
<!--                <el-dropdown-item @click.native="onCardShop"><span class="cursor-pointer">🏪 {{ $t('gacha.cardShop') }}</span></el-dropdown-item>-->
<!--              </el-dropdown-menu>-->
<!--            </el-dropdown>-->
<!--            <el-divider direction="vertical" v-if="userInfo.roleName == roleNameStudent"></el-divider>-->
            <svg width="36" height="36" viewBox="-2 -2 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" @click="onCoinRecord">
              <g>
                <circle cx="12" cy="12" r="11" fill="#F59E0B" stroke="#D97706" stroke-width="1.5" />
                <circle cx="12" cy="12" r="8" fill="#FCD34D" opacity="0.5" />
                <text x="12" y="16" text-anchor="middle" font-size="9" font-weight="800" fill="#92400E" font-family="Nunito,sans-serif">M</text>
              </g>
            </svg>
            <div  @click="onCoinRecord" class="stat-num shimmer-gold">{{ Number(userCardsRoleNum).toLocaleString() }}</div>
            <el-divider direction="vertical" v-if="userInfo.roleName == roleNameStudent"></el-divider>


          <img class="cursor-pointer" v-if="userInfo.roleName == roleNameStudent" style="width: 1.7rem; height: 1.7rem" @click="help" src="@/assets/images/way.png" />
          <el-divider direction="vertical" v-if="userInfo.roleName == roleNameStudent"></el-divider>
          <img class="cursor-pointer" style="width: 2rem; height: 2rem" @click="onWhatsapp" src="@/assets/images/phone.png" />
          <el-divider direction="vertical"></el-divider>
          <button v-if="home && userInfo.roleName != roleNameStudent" @click="onSubscribe" class="subscribe cursor-pointer">
            {{ $t("other.order") }}
          </button>
          <div class="cursor-pointer" v-if="userInfo.roleName != roleNameParent && userInfo.roleName != roleNameStudent" @click="onLogin">
            <img class="userInfo-avatar-img" src="@/assets/images/login.png" />
            {{ $t("other.login") }}
          </div>
          <el-dropdown trigger="click" v-if="userInfo.roleName == roleNameParent">
            <div class="cursor-pointer">
              <img class="userInfo-avatar-img" src="@/assets/images/exit.png" />
              {{ $t("other.exit") }}
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="$router.push({ path: '/parentProfile' })"><span class="cursor-pointer">家長資料</span></el-dropdown-item>
              <el-dropdown-item divided @click.native.capture="onLogOut">
                <span class="cursor-pointer">{{ $t("other.exit") }}</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown trigger="click" v-if="userInfo.roleName == roleNameStudent">
            <el-avatar class="cursor-pointer" :src="getAvatar"></el-avatar>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="onAnswerResult"><span class="cursor-pointer">{{ $t("studentProgramme.answerRecord") }}</span></el-dropdown-item>
              <el-dropdown-item @click.native="onStudentAccount"><span class="cursor-pointer">{{ $t("studentProgramme.myFile") }}</span></el-dropdown-item>
              <el-dropdown-item @click.native="onSelectSubscribed"><span class="cursor-pointer">{{ $t("studentProgramme.courseSwitching") }}</span></el-dropdown-item>
              <el-dropdown-item ><span class="cursor-pointer">V260601a</span></el-dropdown-item>
              <el-dropdown-item divided @click.native.capture="onLogOut">
                <span class="cursor-pointer">{{ $t("other.exit") }}</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>

    <div class="header-phone">
      <img
          :style="{ visibility: userInfo.roleName == roleNameStudent ? '' : '' }"
          src="@/assets/images/icon-more.png"
          class="cursor-pointer"
          @click="drawer = !drawer"
          style="height: 2rem; width: 2rem"
      />
      <!-- <i class="el-icon-more" @click="drawer = !drawer"></i> -->
      <el-drawer :visible.sync="drawer" direction="ltr" size="100%" :modal="false">
        <Menu @closeDrawer="drawer = false" :home="home"></Menu>
        <div slot="title" style="text-align: center">
          <img class="logo-img cursor-pointer" @click="onLogoImageClick" src="@/assets/images/logo.jpeg" />
        </div>
      </el-drawer>
      <img class="logo-img cursor-pointer" @click="onLogoImageClick" src="@/assets/images/logo.jpeg" />


      <el-dropdown trigger="click" v-if="userInfo.roleName == roleNameStudent">
        <el-badge :value="countNewHomework" v-if="userInfo.roleName == roleNameStudent" class="item cursor-pointer">
          <i class="el-icon-s-order" @click="testMode" style="font-size: 30px;color: #9b9b9b"></i>
        </el-badge>
      </el-dropdown>
      <el-divider direction="vertical"></el-divider>
      <el-dropdown trigger="click" v-if="userInfo.roleName == roleNameStudent" style="border-radius: 24px">
        <div class="relative">
          <button
              class="relative flex items-center justify-center rounded-2xl transition-all active:scale-95"
              title="Card sections"
              :style="btnStyle"
          >
            <span class="text-xl leading-none" style="font-size: 16px;">{{ btnIcon }}</span>
            <span class="absolute -bottom-0.5 -right-0.5 w-3 h-3 rounded-full border-2 border-white" :style="dotStyle"></span>
          </button>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="onGacha"><span class="cursor-pointer">🎴 {{ $t('gacha.luckyGacha') }}</span></el-dropdown-item>
          <el-dropdown-item @click.native="onMyGacha"><span class="cursor-pointer">📦 {{ $t('gacha.myCollection') }}</span></el-dropdown-item>
          <el-dropdown-item @click.native="onCardShop"><span class="cursor-pointer">🏪 {{ $t('gacha.cardShop') }}</span></el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-divider direction="vertical"></el-divider>
      <svg width="36" height="36" viewBox="-2 -2 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g>
          <circle cx="12" cy="12" r="11" fill="#F59E0B" stroke="#D97706" stroke-width="1.5" />
          <circle cx="12" cy="12" r="8" fill="#FCD34D" opacity="0.5" />
          <text x="12" y="16" text-anchor="middle" font-size="9" font-weight="800" fill="#92400E" font-family="Nunito,sans-serif">M</text>
        </g>
      </svg>
      <div class="stat-num shimmer-gold">{{ Number(userCardsRoleNum).toLocaleString() }}</div>

      <el-divider direction="vertical"></el-divider>
      <button v-if="home && userInfo.roleName != roleNameStudent" @click="onSubscribe" class="subscribe cursor-pointer">
        {{ $t("other.order") }}
      </button>
      <div class="cursor-pointer" v-if="userInfo.roleName != roleNameParent && userInfo.roleName != roleNameStudent" @click="onLogin">
        <img class="userInfo-avatar-img" src="@/assets/images/login.png" />
        {{ $t("other.login") }}
      </div>
      <el-dropdown trigger="click" v-if="userInfo.roleName == roleNameParent">
        <div class="cursor-pointer">
          <img class="userInfo-avatar-img" src="@/assets/images/exit.png" />
          {{ $t("other.exit") }}
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="$router.push({ path: '/parentProfile' })"><span class="cursor-pointer">家長資料</span></el-dropdown-item>
          <el-dropdown-item divided @click.native.capture="onLogOut">
            <span class="cursor-pointer">{{ $t("other.exit") }}</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>


      <el-dropdown trigger="click" v-if="userInfo.roleName == roleNameStudent">
        <el-avatar class="cursor-pointer" :src="getAvatar"></el-avatar>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="onGacha"><span class="cursor-pointer">{{ $t('gacha.luckyGacha') }}</span></el-dropdown-item>
          <el-dropdown-item @click.native="onMyGacha"><span class="cursor-pointer">{{ $t('gacha.myCollection') }}</span></el-dropdown-item>
          <el-dropdown-item @click.native="onCardShop"><span class="cursor-pointer">{{ $t('gacha.cardShop') }}</span></el-dropdown-item>
          <el-dropdown-item @click.native="onAnswerResult"><span class="cursor-pointer">{{ $t("studentProgramme.answerRecord") }}</span></el-dropdown-item>
          <el-dropdown-item @click.native="onStudentAccount"><span class="cursor-pointer">{{ $t("studentProgramme.myFile") }}</span></el-dropdown-item>
          <el-dropdown-item @click.native="onSelectSubscribed"><span class="cursor-pointer">{{ $t("studentProgramme.courseSwitching") }}</span></el-dropdown-item>
          <el-dropdown-item divided @click.native.capture="onLogOut">
            <span class="cursor-pointer">{{ $t("other.exit") }}</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <span class="cursor-pointer" v-else-if="userInfo.roleName == roleNameParent" @click="onLogOut">{{ $t("dashboard.logOut") }}</span>
      <span v-else style="width: 2rem"></span>

    </div>
    <!-- 自製首次登入獎勵彈窗，唔使用el-dialog -->
    <div v-if="showFirstLoginModal" class="custom-modal-wrap">
      <div class="custom-modal">
        <div class="reward-modal-inner">
          <!-- 星星圖示 -->
          <svg width="80" height="80" viewBox="0 0 24 24" fill="#FFD029" class="star-icon">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
          <h2 class="greet-text">{{ $t('studentProgramme.firstLoginWelcome') }}</h2>

          <!-- 獎勵卡片 -->
          <div class="reward-card">
            <svg width="48" height="48" viewBox="-2 -2 28 28" fill="none">
              <g>
                <circle cx="12" cy="12" r="11" fill="#F59E0B" stroke="#D97706" stroke-width="1.5" />
                <circle cx="12" cy="12" r="8" fill="#FCD34D" opacity="0.5" />
                <text x="12" y="16" text-anchor="middle" font-size="9" font-weight="800" fill="#92400E" font-family="Nunito,sans-serif">M</text>
              </g>
            </svg>
            <div class="reward-info">
              <div class="plus-num">+3</div>
              <div class="coin-desc">{{ $t('studentProgramme.firstLoginCoinText') }}</div>
            </div>
          </div>

          <!-- 領取按鈕 -->
          <button class="claim-btn" @click="onClaimReward">
            {{ $t('studentProgramme.claimReward') }}
          </button>

          <button class="claim-btn" @click="viewTask" style="margin-top: 10px;">
            {{ $t('studentProgramme.viewTask') }}
          </button>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import { logout } from "@/api/security";
import {removeToken, removeAll, getUserInfo, setUserInfo} from "@/utils/auth";
import Menu from "./Menu";
import cmi from "@/views/student-programme/cmi";
import {getCountNewHomework,getCountDailyTask,firstLogin} from "@/api/homework";
import {getProfile, getStudying,getAnswerToRedisKeyList} from "@/api/user";
import moment from "moment";
import {getUserCardsRoleNum} from "@/api/cards";

export default {
  props: {
    security: {
      type: Boolean,
      default: false,
    },
    home: {
      type: Boolean,
      default: false,
    },
    noFaq: {
      type: Boolean,
      default: false,
    },
  },
  components: { Menu },
  data() {
    return {
      links:null,
      avatar: null,
      showFirstLoginModal: false, // 控制彈窗顯示
      carts: [],
      detail: {},
      circleUrl: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      whatsapp: "https://api.whatsapp.com/send/?phone=85260195577&text&type=phone_number&app_absent=0", //'https://chat.whatsapp.com/SomeLettersandsomeNUMBERS',
      drawer: false,
      // 用于存储定时器ID，以便在组件销毁时清除
      refreshTimer: null,
      countNewHomework: '',
      firstLogin: false,
      dailyTask:[],
      dailyTaskWorkId: null,
      dailyTaskGradeId: null,
      userCardsRoleNum:0
    };
  },
  created() {
    this.getStudying();
    this.getAnswerToRedisKeyList();
    this.getUserCardsRoleNum();
    setTimeout(() => {

      // 组件创建时立即执行一次
      this.fetchCountNewHomework();
      this.getCountDailyTask();
      this.getFirstLogin();
    }, 500);
    // 初始化判断当前路由，决定是否开启轮询
    this.checkStartCardTimer();
  },
  beforeUnmount() {
    // 组件销毁前，清除定时器，防止内存泄漏
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
    }
  },
  watch: {
    "$store.getters.language": {
      handler(v) {
        this.$i18n.locale = v;
      },
      deep: true,
    },
    // 监听路由变化
    $route() {
      // 路由一变，先把旧定时器清掉
      this.clearCardTimer();
      this.checkStartCardTimer();
    }
  },
  beforeDestroy() {
    // 组件销毁，清除定时器，防止内存泄漏
    this.clearCardTimer();
  },
  computed: {
    btnIcon() {
      const path = this.$route.path
      if(path === '/gacha') return '🎴'
      if(path === '/myGacha') return '📦'
      if(path === '/cardShop') return '🏪'
      return '🏪' // 默认图标
    },
    btnIconY() {
      const path = this.$route.path
      if(path === '/gacha') return '🎴'+this.$t('gacha.luckyGacha')
      if(path === '/myGacha') return '📦'+this.$t('gacha.myCollection')
      if(path === '/cardShop') return '🏪'+this.$t('gacha.cardShop')
      return '🏪'+this.$t('gacha.cardShop') // 默认图标
    },
    btnIconX() {
      const path = this.$route.path
      const isStudent = this.userInfo.roleName === this.roleNameStudent
      const defaultObj = {
        showImg: true,
        imgSrc: require('@/assets/images/adventure-mode.png'),
        label: this.$t('studentProgramme.adventureMode')
      }
      if (!isStudent) return defaultObj

      const map = {
        '/adventure': {
          showImg: true,
          imgSrc: require('@/assets/images/adventure-mode.png'),
          label: this.$t('studentProgramme.adventureMode')
        },
        '/libraryMode': {
          showImg: true,
          imgSrc: require('@/assets/images/library-mode.png'),
          label: this.$t('studentProgramme.libraryMode')
        }
      }
      return map[path] || defaultObj
    },
    btnStyleX() {
      const path = this.$route.path
      // 配色方案
      const map = {
        '/adventure': {
          bg: 'rgb(254, 242, 242)',
          border: 'rgb(213,121,9)',
          shadowColor: 'rgba(239, 68, 68, 0.133)'
        },
        '/libraryMode': {
          bg: 'rgb(237, 233, 254)',
          border: 'rgb(191,10,212)',
          shadowColor: 'rgba(124, 58, 237, 0.133)'
        },
        '/testMode': {
          bg: 'rgb(224, 242, 254)',
          border: 'rgb(3,166,241)',
          shadowColor: 'rgba(14, 165, 233, 0.133)'
        }
      }
      const cfg = map[path] || map['/testMode']
      return {
        height:'40px',
        background: cfg.bg,
        border: `2px solid ${cfg.border}`,
        boxShadow: `${cfg.shadowColor} 0px 0px 0px 3px`,
        borderRadius:'16px'
      }
    },
    btnStyle() {
      const path = this.$route.path
      // 配色方案
      const map = {
        '/gacha': {
          bg: 'rgb(254, 242, 242)',
          border: 'rgb(239, 68, 68)',
          shadowColor: 'rgba(239, 68, 68, 0.133)'
        },
        '/myGacha': {
          bg: 'rgb(237, 233, 254)',
          border: 'rgb(124, 58, 237)',
          shadowColor: 'rgba(124, 58, 237, 0.133)'
        },
        '/cardShop': {
          bg: 'rgb(224, 242, 254)',
          border: 'rgb(14, 165, 233)',
          shadowColor: 'rgba(14, 165, 233, 0.133)'
        }
      }
      const cfg = map[path] || map['/cardShop']
      return {
        height:'40px',
        width: '40px',
        background: cfg.bg,
        border: `2px solid ${cfg.border}`,
        boxShadow: `${cfg.shadowColor} 0px 0px 0px 3px`,
        borderRadius:'16px'
      }
    },
    btnStyleY() {
      const path = this.$route.path
      // 配色方案
      const map = {
        '/gacha': {
          bg: 'rgb(254, 242, 242)',
          border: 'rgb(239, 68, 68)',
          shadowColor: 'rgba(239, 68, 68, 0.133)'
        },
        '/myGacha': {
          bg: 'rgb(237, 233, 254)',
          border: 'rgb(124, 58, 237)',
          shadowColor: 'rgba(124, 58, 237, 0.133)'
        },
        '/cardShop': {
          bg: 'rgb(224, 242, 254)',
          border: 'rgb(14, 165, 233)',
          shadowColor: 'rgba(14, 165, 233, 0.133)'
        }
      }
      const cfg = map[path] || map['/cardShop']
      return {
        height:'40px',
        background: cfg.bg,
        border: `2px solid ${cfg.border}`,
        boxShadow: `${cfg.shadowColor} 0px 0px 0px 3px`,
        borderRadius:'16px'
      }
    },
    dotStyleX() {
      const path = this.$route.path
      const map = {
        '/adventure': { background: 'rgb(243,109,6)' },
        '/libraryMode': { background: 'rgb(76,11,187)' },
        '/testMode': { background: 'rgb(9,70,248)' }
      }
      return map[path] || map['/cardShop']
    },
    dotStyle() {
      const path = this.$route.path
      const map = {
        '/gacha': { background: 'rgb(239, 68, 68)' },
        '/myGacha': { background: 'rgb(124, 58, 237)' },
        '/cardShop': { background: 'rgb(14, 165, 233)' }
      }
      return map[path] || map['/cardShop']
    },
    getAvatar() {
      let avatar = getUserInfo("userProfile").avatar;
      return this.avatar || avatar || this.circleUrl;
    },
  },
  mounted() {
    cmi.$on("avatarChange", (avatar) => {
      this.avatar = avatar;
    });
  },
  destroyed() {
    cmi.$off("avatarChange");
  },
  methods: {
    modeChange(index) {
      if (index == 1) this.$router.push({ path: "/adventure" });
      if (index == 2) this.$router.push({ path: "/libraryMode" });
      if (index == 3) this.$router.push({ path: "/testMode" });
    },
    checkStartCardTimer() {
      // 判断是否抽卡 / 卡牌商店页面
      const targetPaths = ['/gacha', '/cardShop'];
      if (targetPaths.includes(this.$route.path)) {
        // 先立即执行一次，再开启10秒轮询
        this.getUserCardsRoleNum();
        this.cardRoleNumTimer = setInterval(() => {
          this.getUserCardsRoleNum();
        }, 10000);
      }
    },
    clearCardTimer() {
      if (this.cardRoleNumTimer) {
        clearInterval(this.cardRoleNumTimer);
        this.cardRoleNumTimer = null;
      }
    },
    async getUserCardsRoleNum() {
      if (this.userInfo && this.userInfo.roleName === this.roleNameStudent) {
        const res = await getUserCardsRoleNum();
        this.userCardsRoleNum = res.data;
      }
    },
    getUserInfo(){
      getProfile().then((v) => {
        if (this.userInfo.roleName == this.roleNameParent) {
          setUserInfo("userProfile", v.data);
        } else if (this.userInfo.roleName == this.roleNameStudent) {
          let detail = JSON.parse(JSON.stringify(v.data));
          detail.subscriptionIndex=0
          setUserInfo("userProfile", detail);
          this.$store.dispatch(
              "setGradeId",
              detail.subscriptions[detail.subscriptionIndex].gradeId
          );
          if(detail.studying==1){
            this.$i18n.locale = "en";
            this.$store.dispatch("setLanguage", "en");
          }else if(detail.studying==0){
            this.$i18n.locale = "zh_tc";
            this.$store.dispatch("setLanguage", "zh_tc");
          }
        }
      });
    },
    onClaimReward() {
      this.showFirstLoginModal = false;
      this.$message({
        message: this.$t('studentProgramme.addCoin', { num: 3 }),
        type: 'success'
      });
      // 跳轉抽卡頁
      // this.$router.push({ path: '/gacha' });
    },
    viewTask() {
      this.showFirstLoginModal = false;
      this.$message({
        message: this.$t('studentProgramme.addCoin', { num: 3 }),
        type: 'success'
      });
      // 跳轉抽卡頁
      this.onViewTasks();
    },
    getFirstLogin(){
      if (this.userInfo && this.userInfo.roleName === this.roleNameStudent) {
        firstLogin().then((v) => {
          this.firstLogin = v.data;
          if (this.firstLogin === 1) {
            // 開啟自訂彈窗，不再使用$msgbox
            this.showFirstLoginModal = true;
          }
        });
      }
    },
        // 将数据获取逻辑封装成一个方法
    async fetchCountNewHomework() {
      if (this.userInfo && this.userInfo.roleName === this.roleNameStudent) {
        getCountNewHomework().then((v) => {
          this.countNewHomework=v.data;
        });
      }
    },
    // 将数据获取逻辑封装成一个方法
    async getCountDailyTask() {
      if (this.userInfo && this.userInfo.roleName === this.roleNameStudent) {
        getCountDailyTask().then((v) => {
          this.dailyTask=v.data;
          this.dailyTaskWorkId=this.dailyTask.id;
          this.dailyTaskGradeId=this.dailyTask.gradeId;
        });
      }
    },
    toExamination() {
      const routeObj = this.$router.resolve({
        path: "/examination",
        query: {
          type: "work",
          id: this.dailyTaskWorkId,
          gradeId: this.dailyTaskGradeId,
          startTime: moment().format("YYYY-MM-DD HH:mm:ss")
        },
      });
      // _blank = 新標籤頁
      window.open(routeObj.href, '_blank');
    },
    isStudentPage() {
      const STUDENT_PAGE_ROUTES = [
        "/libraryMode",
        "/testMode",
        "/adventure",
        "/studentAccount",
        "/assessment",
        "/examination",
        "/answerResult",
        "/coinRecord",
        "/tasks",
        "/help",
        "/gacha",
        "/myGacha",
        "/cardShop",
        "/selectStudying",
        "/examinationAnswerResult"
      ];
      return STUDENT_PAGE_ROUTES.includes(this.$route.path);
    },
    // 将数据获取逻辑封装成一个方法
    async getStudying() {
      // 2. refresh 结束后请求就读状态
      if (this.isStudentPage()) {
        const studying = await getStudying();
        if (studying.data === 1) {
          this.setGlobalLang("en");
        } else if (studying.data === 0) {
          this.setGlobalLang("zh_tc");
        }
      }else{
        this.setGlobalLang("zh_tc");
      }
    },
    async getAnswerToRedisKeyList() {
      // 2. refresh 结束后请求就读状态
      if (this.isStudentPage()) {
        const e = await getAnswerToRedisKeyList();
        const domain = `${process.env.VUE_APP_URL}/#`;
        this.links = e.data.data?.map((key,index) => {
          const nameMatch = key.match(/NAME=(.*?)_URL=/);
          const urlMatch = key.match(/_URL=(.*)$/);
          const extractedName = nameMatch ? nameMatch[1] : null;
          const extractedUrl = urlMatch ? urlMatch[1] : key.includes('/examination?') ? key.substring(key.indexOf('/examination?')) : key;
          // 生成当前时间：2026-08-25 16:43:24
          const now = new Date();
          const timeStr =
              '&startTime='+now.getFullYear() + '-' +
              String(now.getMonth() + 1).padStart(2, '0') + '-' +
              String(now.getDate()).padStart(2, '0') + ' ' +
              String(now.getHours()).padStart(2, '0') + ':' +
              String(now.getMinutes()).padStart(2, '0') + ':' +
              String(now.getSeconds()).padStart(2, '0');

          // name 为空时使用默认文本
          const displayName = extractedName || this.$t('redis.linkText', { index: index + 1 });
        return `<a href="${domain}${extractedUrl}${timeStr}" target="_self" style="display:inline-block; padding:6px 12px; margin:4px 0; background:#FFF3E0; border-radius:8px; color:#E65100; text-decoration:none; font-size:16px; font-weight:bold; border:2px solid #FFB74D; transition:all 0.3s;" onmouseover="this.style.background='#FFE0B2';this.style.transform='scale(1.02)'" onmouseout="this.style.background='#FFF3E0';this.style.transform='scale(1)'">${displayName}</a>`;
      }).filter(Boolean).join('<br>');

        if (this.links) {
          this.$notify({
            title: this.$t('redis.title'),
            message: this.links,
            position: 'bottom-right',
            dangerouslyUseHTMLString: true,
            customClass: 'custom-notify'
          });
        }

      }
    },
    /** 统一切换全局语言 */
    setGlobalLang(lang) {
      this.$i18n.locale = lang;
      this.$store.dispatch("setLanguage", lang);
      localStorage.setItem("app_lang", lang);
    },
    onAbout() {
      this.$router.push({ name: "about" });
    },
    onPlatform() {
      this.$router.push({ name: "platform" });
    },
    onFaq() {
      this.$router.push({ name: "faq" });
    },
    onContact() {
      this.$router.push({ name: "contact" });
    },
    onSitemap() {
      this.$router.push({ name: "sitemap" });
    },
    onRefund() {
      this.$router.push({ name: "refund" });
    },
    onPrivacy() {
      this.$router.push({ name: "privacy" });
    },
    onDisclaimer() {
      this.$router.push({ name: "disclaimer" });
    },
    onLangText(v) {
      this.$i18n.locale = v;
      this.$store.dispatch("setLanguage", v);
      window.location.reload();
    },
    onWhatsapp() {
      window.open(this.whatsapp, "_blank");
    },
    onGacha() {
      const newPath = "/gacha";
      const currentPath = this.$route.path;
      if (currentPath !== newPath) {
        this.$router.push({ path: newPath });
      }
    },
    onMyGacha() {
      const newPath = "/myGacha";
      const currentPath = this.$route.path;
      if (currentPath !== newPath) {
        this.$router.push({ path: newPath });
      }
    },
    onCardShop() {
      const newPath = "/cardShop";
      const currentPath = this.$route.path;
      if (currentPath !== newPath) {
        this.$router.push({ path: newPath });
      }
    },
    testMode(){
      const newPath = "/testMode";
      const currentPath = this.$route.path;
      if (currentPath !== newPath) {
        this.$router.push({ path: newPath });
      }
    },
    onCoinRecord(){
      const newPath = "/coinRecord";
      const currentPath = this.$route.path;
      if (currentPath !== newPath) {
        this.$router.push({ path: newPath });
      }
    },
    onViewTasks(){
      const newPath = "/tasks";
      const currentPath = this.$route.path;
      if (currentPath !== newPath) {
        this.$router.push({ path: newPath });
      }
    },
    onSubscribe() {
      if (this.userInfo.roleName != this.roleNameStudent) this.$router.push({ name: "cart" });
    },
    onLogoImageClick() {
      if (this.userInfo.roleName == this.roleNameStudent) {
        this.$router.push({ path: "/adventure" });
      } else if (this.userInfo.roleName == this.roleNameParent) {
        this.$router.push({ path: "/studyRecordCount" });
      }else{
        this.$router.push({ path: "/home" });
      }
      this.drawer = false;
    },
    onLogin() {
      this.$router.push({ path: "/login" });
    },
    onAnswerResult() {
      this.$router.push({ path: "/answerResult" });
    },
    onStudentAccount() {
      this.$router.push({ path: "/studentAccount" });
    },
    onSelectSubscribed() {
      this.$router.push({ path: "/selectStudying" });
    },
    onLogOut() {
      this.$confirm("", "你確定登出嗎？\nAre you sure want to logout?", {
        confirmButtonText: "登出 Logout",
        cancelButtonText: "返回 Back",
        center: true,
        showClose: false,
        closeOnClickModal: false,
        customClass: "exit-box",
        cancelButtonClass: "exit-cancel",
        confirmButtonClass: "exit-confirm",
      })
          .then(() => {
            this.logout();
          })
          .catch(() => {});
    },
    toIsFirst() {
      this.detail = getUserInfo("userProfile");
      this.detail.avatar=null;
      setUserInfo("userProfile", this.detail);
      location.reload();
    },
    help() {
      this.$router.push({ path: "/help" });
    },
    logout() {
      let form = {
        refreshToken: this.refreshToken,
      };
      logout(form)
          .then(() => {
            removeToken();
            removeAll();
            window.sessionStorage.clear();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            removeToken();
            removeAll();
            window.sessionStorage.clear();
            this.$router.push({ path: "/login" });
          });
      removeToken();
      removeAll();
      window.sessionStorage.clear();
      this.$router.push({ path: "/login" });
    },
  },
};
</script>

<style lang="scss" scoped>
.sticky-box {
  position: -webkit-sticky;
  position: sticky;
  top: 0px;
  z-index: 2000;
  box-shadow: 0 0.25rem 0.25rem rgba(0, 0, 0, 0.1);
  font-size: 18px;
}
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 3.25rem;
  //padding: 0 1.25rem;
  padding: 0 1.5rem;
  background-color: #fff;
}

.logo {
  display: flex;
  align-items: center;
}
.logo-img {
  height: 3.25rem;
}
.logo-text {
  font-size: 1.25rem;
  font-weight: bold;
}
.cursor-pointer {
  margin: 0 0.5vw;
}
.userinfo {
  display: flex;
  align-items: center;
}
.subscribe {
  background: #fcc03a;
  box-shadow: 0px 0.375rem 0 #c28c00;
  border: none;
  color: #444444;
  border-radius: 100px;
  //padding:0.375rem 1.25rem;
  width: 100px;
  height: 25px;
  margin: auto 1rem;
  font-size: 18px;
}
.userinfo-cursor {
  cursor: pointer;
}
.userInfo-avatar-img {
  width: 1.4rem;
  vertical-align: sub;
  margin-right: 0.125rem;
}
.userInfo-avatar-img-avatar {
  width: 2rem;
}
.header-phone {
  display: none;
}
.el-dropdown {
  font-size: 1rem;
}
@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
  .header {
    display: none;
  }
  .header-phone {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 3.5rem;
    padding: 0 1.25rem;
    background-color: #fff;
    .logo-img {
      height: 2.5rem;
    }
  }
  .el-dropdown {
    font-size: 1.5625rem;
  }

  ::v-deep {
    .el-drawer__header {
      padding: 1.25rem;
      margin-bottom: 0;
      & .el-drawer__close-btn {
        position: absolute;
        right: 1.25rem;
      }
    }
  }
}
// 自製彈窗樣式
.custom-modal-wrap {
  background: rgba(0, 0, 0, 0.45);  // 半透明黑遮罩
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
  pointer-events: none; // 背景唔會攔截點擊（等同 :modal="false"）
  .custom-modal {
    pointer-events: auto; // 彈窗入面可以點擊
    width: 440px;
    background: #ffffff;
    border-radius: 24px; // 圓角直接寫呢度，完全受控
    overflow: hidden;
    padding: 32px 24px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.12);
  }
  .reward-modal-inner {
    text-align: center;
    .star-icon {
      margin-bottom:16px;
    }
    .greet-text {
      margin:0 0 8px;
      font-size:32px;
      color:#222;
      font-weight:700;
    }
    .welcome-text {
      margin:0 0 24px;
      font-size:20px;
      color:#926B0F;
    }
    .reward-card {
      background:linear-gradient(180deg, #FFF9DD 0%, #FFEDB4 100%);
      border:2px solid #FFD046;
      border-radius:16px;
      padding:20px 16px;
      margin-bottom:28px;
      display:flex;
      align-items:center;
      gap:14px;
      text-align:left;
      .plus-num {
        font-size:32px;
        font-weight:bold;
        color:#D97706;
      }
      .coin-desc {
        font-size:18px;
        color:#784700;
      }
    }
    .claim-btn {
      width:100%;
      height:56px;
      background: linear-gradient(180deg, #FF9F1C 0%, #E67E00 100%);
      border: none;
      border-radius: 16px;
      font-size: 22px;
      font-weight: bold;
      color: #fff;
      cursor: pointer;
    }
  }
}
.stat-num {
  font-size:16px;
  color:#facc15;
  font-family: Nunito;
  font-weight: 900;
}
.shimmer-gold {
  background: linear-gradient(90deg, #D97706, #FCD34D, #F59E0B, #FCD34D, #D97706);
  background-size: 200% auto;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: shimmer 2.5s linear infinite;
}
</style>